import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { DateGetYearExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateGetYearExpression";

export class DateGetYearExpressionEditor extends ExpressionRuleEditor<DateGetYearExpression> {
    render() {
        return (
            <ObserveState
                listenTo={this.ruleData!.value1!}
                control={() => (
                    <ExpressionPiece hasChild={!!this.ruleData!.value1!.subExpression}>
                        get year
                        <BracketedDiv hasChild={!!this.ruleData!.value1!.subExpression}>
                            <ExpressionValueRenderer el={this.ruleData!.value1!} />
                        </BracketedDiv>
                    </ExpressionPiece>
                )}
            />
        );
    }
}
